export default "__VITE_PUBLIC_ASSET__45733169__"